// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointsComparisonSpecificsFromJSON, DatapointsComparisonSpecificsToJSON, DatapointsRequestFromJSON, DatapointsRequestToJSON, } from './';
export function DatapointsComparisonRequestFromJSON(json) {
    return {
        ...DatapointsComparisonSpecificsFromJSON(json),
        ...DatapointsRequestFromJSON(json),
    };
}
export function DatapointsComparisonRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...DatapointsComparisonSpecificsToJSON(value),
        ...DatapointsRequestToJSON(value),
    };
}
